export const updateClosedNotifications = (value) => {
  if (window?.sessionStorage) {
    const notificationList = JSON.parse(window?.sessionStorage?.getItem('notificationList'));
    let closedNotifications = notificationList?.closed ?? [];

    const duplicatedNotification = closedNotifications?.find(
      (element) => element.uid === value.uid,
    );

    if (duplicatedNotification) {
      closedNotifications = closedNotifications.map(
        (item) => ({
          uid: item.uid,
          updatedAt: value.uid === item.uid ? value.updatedAt : item.updatedAt,
        }),
      );
    } else {
      closedNotifications?.push(value);
    }

    window.sessionStorage.setItem('notificationList', JSON.stringify({
      closed: closedNotifications,
    }));
  }
};

export const getClosedNotifications = (notifications) => {
  if (window?.sessionStorage) {
    const notificationList = JSON.parse(window?.sessionStorage?.getItem('notificationList'));
    const closedNotifications = notificationList?.closed ?? [];
    let filteredNotifications = [];

    if (!!notifications && closedNotifications.length !== 0) {
      const matchWithClosedNotifications = notifications?.filter(
        (item) => item.uid === closedNotifications?.find(
          (element) => element.uid === item.uid,
        )?.uid,
      );
      const notUpdatedNotifications = matchWithClosedNotifications?.filter(
        (item) => item.updatedAt === closedNotifications?.find(
          (element) => element.uid === item.uid,
        )?.updatedAt,
      );
      filteredNotifications = notifications?.filter(
        (item) => item.uid !== notUpdatedNotifications.find(
          (element) => item.uid === element.uid,
        )?.uid,
      );

      return filteredNotifications;
    }

    return notifications;
  }

  return null;
};

export default {
  updateClosedNotifications,
  getClosedNotifications,
};
